export default __webpack_public_path__ + "static/media/earth.65331617.jpg";